import { generateClient } from 'aws-amplify/api'
import { getOrgDetails as getOrgDetailsQuery } from '@/graphql/queries'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

export async function getOrgDetailsRequest() {
  try {
    const { data, errors } = await client.graphql({
      query: getOrgDetailsQuery,
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data.getOrgDetails)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to load organisation details'),
    }
  }
}
